module.exports = "<div id=\"footer\">\n  <div class=\"inner\">\n    <div>\n      <small>\n        <a href=\"#\" ng-click=\"footer.logout()\">Abmelden</a>\n        |\n        <a href=\"http://www.knips-o-mat.de/impressum/\" target=\"_blank\">Impressum</a>\n      </small>\n    </div>\n    <div>\n      <small>Copyright &copy; <a href=\"http://www.knips-o-mat.de/\" target=\"_blank\">knips-o-mat.de</a></small>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.html
// module id = 423
// module chunks = 0